export default __webpack_public_path__ + "static/media/cartwo.7c151669.png";